import {useState} from 'react';
import Hero from '../components/Hero';
import { useLanguage } from '../i18n/LanguageContext';
import { useGenericEffect } from '../components/UseGenericEffect';
import Product from '../content/product';
import Event from '../content/event';

export default function Pricing() {
  const { strings } = useLanguage();

  const map = {
    'product': <Product lang={strings.lang_code}/>,
    'event': <Event lang={strings.lang_code}/>,
  };    

  function get(){
    setContent(map[document.getElementById('loadstate').textContent]);
  }

   useGenericEffect(() => { 
    get(); 
   }, [strings.lang_code]);
   const [content, setContent] = useState(map['product']);

  return (
    <>
      <Hero title={strings.pages.pricing.title} eyebrow={strings.pages.pricing.eyebrow} />
      <main className="page-content">
          <div class="content-container-menu" id="content-container-menu">       
              <div className="menu-item" onClick={() => get()} id="product">{strings.pages.pricing.products}</div>       
              <div className="menu-item" onClick={() => get()} id="event">{strings.pages.pricing.events}</div>       
          </div>  
          <div class="content-table max-centered">
              <div class="content-container">   
                  <div class="content-container-main show" id="content-container-main">
                      {content}
                  </div>   
              </div>
               <div class="hidden" id="loadstate">product</div>
       </div>
      </main>
    </>
  );
}